import { render, staticRenderFns } from "./SPositionSearch.vue?vue&type=template&id=27248fc6&scoped=true"
import script from "./SPositionSearch.vue?vue&type=script&lang=js"
export * from "./SPositionSearch.vue?vue&type=script&lang=js"
import style0 from "./SPositionSearch.vue?vue&type=style&index=0&id=27248fc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27248fc6",
  null
  
)

export default component.exports